<soft-page>
  <soft-page-header>
    <div
      class="flex flex-col-reverse w-full"
    >
      <soft-step-header [steps]="steps" [currentIndex]="2" #stepper></soft-step-header>
      <soft-default-header
        class="px-0! pt-0! mt-0!"
        [overline]="stepper.stepText"
        [title]="stepper.current()?.header"
        [subtitle]="stepper.current()?.subHeader"
      >
      </soft-default-header>
    </div>
  </soft-page-header>

  <soft-page-panel class="overflow-y-auto" panelStyle="plain">

    @if (bestellung$ | async; as bestellung) {
      <div class="flex">
        <div class="flex flex-col w-full h-full gap-4 pb-3">
          <soft-kopfdaten
            [isBestellung]="true"
            [bestellung]="bestellung"
            [softScrollIntoView]="((bewegungen$ | async)?.length || 0) > 0"
            scrollBehavior="instant"
          ></soft-kopfdaten>
          @if (!loadingBewes()) {
            <soft-bewegung-list
              [isBestellung]="true"
              [bewegungen]="(bewegungen$ | async) || []"
              (mengeChange)="onQuantityChange($event)"
              (bewelgMengeChange)="onLademittelQuantityChange($event)"
            ></soft-bewegung-list>
          } @else {
            <div class="flex flex-col w-full pb-3">
              <div class="skeleton rounded h-[170px] w-full mt-4" *softRepeat="5"></div>
            </div>
          }
        </div>
      </div>
    }
  </soft-page-panel>
</soft-page>
